import { Component } from '@angular/core';

@Component({
  selector: 'app-page-404-container',
  template: '<app-page404></app-page404>'
})
export class Page404Container {}
